import axios from 'axios';
import { Cookies } from 'react-cookie';
import toURLSearchParams from '../../Domain/utils/toURLSearchParams';

axios.defaults.headers.common['X-CSRFToken'] = new Cookies().get('csrftoken');
const body = document.querySelector('body');

export const dashboard = axios.create({
  method: 'POST',
  baseURL: `https://${body?.getAttribute('api_server_url')}`,
  transformRequest: [
    (data: Record<string, string>, headers) => {
      headers['Access-Control-Allow-Origin'] = '*';
      return toURLSearchParams({
        ...data,
        token: body?.getAttribute('api_admin_token'),
        scenario_id: body?.getAttribute('scenario_id'),
      });
    },
  ],
});

export const httpClient = axios.create({
  headers: {
    'scenario-id': document.body.getAttribute('scenario_id'),
    Authorization: 'Bearer ' + document.body.getAttribute('jwt_admin_token'),
  },
});

httpClient.interceptors.request.use((config) => {
  const token = document.body.getAttribute('jwt_admin_token');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default axios;
